import React from "react";
import {
  Box,
  Typography,
  CssBaseline,
  ThemeProvider,
  useMediaQuery,
} from "@mui/material";
import { StyledButton } from "../../../components/common/Button";
import { ArrowRightAlt } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import theme from "../../../config/theme";

const Common = ({
  title,
  subtitle,
  imgSrc,
  borderColor,
  color,
  marginTop,
  link,
}) => {
  const navigate = useNavigate();

  const handleImageClick = (link) => {
    navigate(link);
  };
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isMobile ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            boxShadow: "0px 8px 24px rgba(115, 19, 185, 0.15)",
            borderRadius: "0.75rem",
            height: "11.25rem",
            width: "21.875rem",
          }}
        >
          <Box sx={{ display: "flex", flex: "1", alignItems: "center" }}>
            <img
              src={imgSrc}
              alt=""
              style={{
                height: "8.639375rem",
                width: "9.520625rem",
                objectFit: "contain",
                marginTop: "1.25rem",
                marginLeft: "0.739375rem",
                marginBottom: "1.360625rem",
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flex: "1",
              alignItems: "center",
              flexDirection: "column",
              marginRight: "0.8125rem",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: "700",
                fontSize: "1rem",
                color: "#212121",
                letterSpacing: "0.0119975rem",
                marginTop: "1.25rem",
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="h4"
              sx={{
                width: "9.5625rem",
                letterSpacing: "0.0071986875rem",
                fontSize: "0.625rem",
                fontWeight: 400,
                color: "#212121",
                textAlign: "center",
                marginTop: "0.5rem",
                lineHeight: "1.125rem",
              }}
            >
              {subtitle}
            </Typography>
            <StyledButton
              variant="outlined"
              style={{
                width: "7.4375rem",
                height: "1.5rem",
                borderColor: borderColor,
                color: color,
                backgroundColor: "#FFFFFF",
                marginTop: "1.313125rem",
              }}
              onClick={() => handleImageClick(link)}
            >
              <Typography
                sx={{
                  fontSize: "0.5rem",
                  fontWeight: 700,
                  letterSpacing: "0.0532384375rem",
                  whiteSpace: "nowrap",
                }}
              >
                KNOW MORE
              </Typography>
              <ArrowRightAlt
                sx={{
                  marginLeft: "0.50125rem",
                  height: "0.8rem",
                  width: "0.8rem",
                }}
              />
            </StyledButton>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            boxShadow: "0px 8px 24px rgba(115, 19, 185, 0.15)",
            borderRadius: "0.75rem",
          }}
        >
          <Box sx={{ marginTop: "3.75rem" }}>
            <img
              src={imgSrc}
              alt=""
              style={{
                height: "18.625rem",
                width: "20.50625rem",
                objectFit: "contain",
              }}
            />
          </Box>
          <Box
            sx={{
              marginTop: "3.75rem",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: "700",
                fontSize: "2rem",
                color: "#212121",
                letterSpacing: "0.015625rem",
              }}
            >
              {title}
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "1.5rem",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                width: "21rem",
                letterSpacing: "0.009375rem",
                fontSize: "1.125rem",
                color: "#212121",
                textAlign: "center",
              }}
            >
              {subtitle}
            </Typography>
          </Box>
          <Box>
            <StyledButton
              variant="outlined"
              style={{
                width: "15.5rem",
                height: "3rem",
                marginBottom: "3.813125rem",
                borderColor: borderColor,
                color: color,
                marginTop: marginTop,
                backgroundColor: "#FFF",
              }}
              onClick={() => handleImageClick(link)}
            >
              KNOW MORE
              <ArrowRightAlt
                sx={{
                  marginLeft: "0.833125rem",
                }}
              />
            </StyledButton>
          </Box>
        </Box>
      )}
    </ThemeProvider>
  );
};

export default Common;